export default "__VITE_ASSET__DE8LuQ0v__"